const { Transaction } = require("@ethereumjs/tx");
const { bufferToHex, bigIntToHex, toBuffer } = require("@ethereumjs/util");
const { ethers }  = require("ethers") ;

/**
 * @param {String} raw
 * @returns 
 */
const decodeRaw = (raw) => {
  if(!raw) {
    return ''
  }
  if(!raw.includes('0x')) {
    raw = `0x${raw}`
  }
  const result = ethers.utils.parseTransaction(raw)
  if (result.type) {
    return {
      nonce: ethers.utils.hexlify(result.nonce),
      maxPriorityFeePerGas: result.maxPriorityFeePerGas?.toHexString() || '',
      maxFeePerGas: result.maxFeePerGas?.toHexString() || '',
      gasLimit: result.gasLimit.toHexString(),
      to: result.to || '',
      value: result.value.toHexString(),
      data: result.data,
    }
  } else {
    return {
      nonce: ethers.utils.hexlify(result.nonce),
      gasPrice: result.gasPrice?.toHexString() || '',
      gasLimit: result.gasLimit.toHexString(),
      to: result.to || '',
      value: result.value.toHexString(),
      data: result.data,
    }
  }
}

/**
 * get ERC20 ABI, includes balanceOf
 * @returns 
 */
const getERC20ABI = () => {
  return [
    {
      constant: true,
      inputs: [
        {
          name: "_owner",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          name: "balance",
          type: "uint256",
        },
      ],
      payable: false,
      type: "function",
    },
    {
      constant: true,
      inputs: [],
      name: "decimals",
      outputs: [
        {
          name: "",
          type: "uint8"
        }
      ],
      payable: false,
      type: "function"
    },
  ]
}

const BigNumberify = (n) => {
  try {
    return ethers.BigNumber.from(n);
  } catch (e) {
    console.error("bigNumberify error", e);
    return undefined;
  }
}

module.exports = {
    decodeRaw,
    getERC20ABI,
    BigNumberify
}